<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Galeria
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastrar Imagens</span>
              </v-card-title>
              <v-layout row wrap>
                <v-flex sm9 md9>
                  <v-text-field
                    label="Nome Galeria"
                    v-model="galeria"
                    type="text"
                  ></v-text-field>
                </v-flex>
                <v-flex sm3 md3>
                  <v-btn color="blue darken-3" 
                    dark v-on:click="addGalerias()">+</v-btn>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="headersImagem"
                :items="galerias"
              >
                <template slot="items" slot-scope="props2">
                  <td>{{ props2.item.dsGaleria }}</td>
                  <td >
                  
                    <v-btn icon class="mx-0" @click="editImage(props2.item)">  
                      <v-icon 
                        small
                        class="mx-0">
                        image
                      </v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="deleteGaleria(props2.item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card>
            <!-- <v-btn @click="save();"> Salvar </v-btn> -->
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogImage" persistent max-width="70%">
      <v-card>
        <v-card-title>
          <span class="headline">Cadastrar Images</span>
        </v-card-title>
        <v-container v-show="carregando">
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="subtitle-1 text-center"
              cols="12"
            >
              Getting your files
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-show="!carregando">
            <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              class="subtitle-1 text-center"
              cols="12"
            >
            <input
                type="file"
                ref="image"
                accept="image/*"
                :multiple="true"
                @change="onFileChange"
              >
            </v-col>
          </v-row>
        </v-container>
        <v-data-table
          :headers="headersImages"
          :items="model.images"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.descricao }}</td>
            <td >
            
              <v-btn icon class="mx-0" @click="deleteImage(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click.native="clearImage()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
  
</template>

<script>
import galeria from "@/services/galeria";

export default {
  name: "home",
  data() {
    return {
      search: "",
      snackbar: false,
      galeria: "",
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      excluindo: {},
      idZabbix: "",
      galerias: [],
      model: { },
      dialogImage: false,
      carregando: false,
      headersImagem: [{
          text: 'Nome Galeria',
          align: 'left',
          sortable: true,
          value: 'dsGaleria'
        },
        { text: 'Ações' }
      ],
      headersImages: [{
          text: 'Nome Galeria',
          align: 'left',
          sortable: true,
          value: 'descricao'
        },
        { text: 'Ações' }
      ],
    };
  },
  async created() {
    this.galerias = await galeria.getGalerias();
  },
  methods: {
    addGalerias: function () {
      if (!this.galerias || this.galerias.length == 0) {
        this.galerias = [];
      }
      if (this.galeria && this.galeria != '') {
        this.galerias.push({dsGaleria: this.galeria});
        this.galeria = '';
      }
    },
    editImage: async function (even) {
      this.dialogImage = true;
      console.log(even);
      this.model = even;
      this.model.internal = undefined;
      this.model.flags = undefined;
      if (!this.model.images) {
        this.model.images = []
      }
    },
    clearImage: function () {
      this.dialogImage = false;
      this.model = {};
    },
    async deleteImage (item) {
      let res = await galeria.removeGaleriaImage(item, this.model._id);
      galeria.getGaleriaId(this.model._id).then(res => {
        this.model = res;
      });
    },
    async deleteGaleria (item) {
      let res = await galeria.removeGaleria(item);
      this.galerias = await galeria.getGalerias();
    },
    
    
    async onFileChange($event){

      this.carregando = true;
      try {
        const files = $event.target.files || $event.dataTransfer.files;
        if (files) {
          var payload = new FormData();
          console.log(this.model);
          payload.set('_id', this.model._id);
          payload.set('dsGaleria', this.model.dsGaleria);
          if (files.length > 0) {
            for (var i = 0; i < files.length; i++) {
              var file = files[i];
              payload.append('filename', file);
            }
            let res = await galeria.saveGaleriaImage(payload);
            this.model = await galeria.getGaleriaId(this.model._id);
            this.carregando = false;
          }
        }
      } catch (e) {
        this.carregando = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/user/GaleriaParam.vue